import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../lib/supabase';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiBell, FiStar, FiPlusCircle } = FiIcons;

export default function Home() {
  const { profile } = useAuth();
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      const { data } = await supabase
        .from('services')
        .select('*')
        .eq('is_active', true)
        .order('display_order', { ascending: true })
        .order('created_at', { ascending: true });
      if (data) setServices(data);
      setLoading(false);
    };
    fetchServices();
  }, []);

  return (
    <div className="p-4 pt-8">
      {/* Header */}
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-2xl font-bold text-brand-navy">Hello, {profile?.full_name?.split(' ')[0] || 'Guest'}</h1>
          <p className="text-gray-500">What would you like to clean today?</p>
        </div>
        <div className="h-12 w-12 bg-white rounded-full flex items-center justify-center shadow-sm border border-gray-100">
          <FiBell className="text-brand-navy text-xl" />
        </div>
      </div>

      {/* Offer Banner */}
      <div className="bg-brand-navy rounded-2xl p-6 mb-8 text-white relative overflow-hidden shadow-premium">
        <div className="relative z-10">
          <span className="bg-brand-gold text-white text-xs font-bold px-2 py-1 rounded mb-2 inline-block">LIMITED TIME</span>
          <h2 className="text-xl font-bold mb-1">Professional Care</h2>
          <p className="text-brand-silver text-sm mb-4">Quality cleaning for all your garments</p>
          <Button variant="accent" size="sm" onClick={() => navigate('/app/book')}>Book Now</Button>
        </div>
        <FiStar className="absolute -right-4 -bottom-4 text-white opacity-10 text-9xl" />
      </div>

      {/* Services Grid */}
      <h3 className="text-lg font-bold text-brand-navy mb-4">Our Services</h3>
      {loading ? (
        <div className="animate-pulse flex space-x-4">
          <div className="flex-1 space-y-4 py-1">
            <div className="h-24 bg-gray-200 rounded-2xl w-full"></div>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-4">
          {services.map((service) => (
            <Card key={service.id} onClick={() => navigate('/app/book')} className="text-center flex flex-col items-center justify-center py-6">
              <div className="h-12 w-12 bg-blue-50 text-brand-navy rounded-full flex items-center justify-center mb-3">
                <SafeIcon name={service.icon_name || 'Feather'} className="text-2xl" />
              </div>
              <h4 className="font-semibold text-gray-800 text-sm mb-1">{service.name}</h4>
              <p className="text-xs text-brand-gold font-medium">Select to book</p>
            </Card>
          ))}
        </div>
      )}

      {/* Quick Action */}
      <div className="mt-8 mb-4">
        <Button size="lg" className="w-full flex items-center justify-center gap-2" onClick={() => navigate('/app/book')}>
          <FiPlusCircle /> Schedule a Pickup
        </Button>
      </div>
    </div>
  );
}